/* eslint-disable no-dupe-class-members */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {Component} from 'react';
import {unitList, unitForm} from '../../../schema/units';
import {departmentList, departmentForm} from '../../../schema/department';
import {serviceGroupList, serviceGroupForm} from '../../../schema/ServiceGroup';
import {serviceList, serviceForm} from '../../../schema/services';
import {doctorList, doctorForm} from '../../../schema/doctors';
import {QueuedoctorList, QueuedoctorForm} from '../../../schema/queueDoctors';
import {userList, userForm} from '../../../schema/user';
import {roleList, roleForm} from '../../../schema/roles';
import {tvList, tvForm} from '../../../schema/tvScreen';
import {Modal, Switch, Icon,Button} from 'antd';
import Inputlayer from '../../FormComponent/Input';
import Btable from '../../FormComponent/bootstrapTable';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Select2 from '../../FormComponent/select2';
import Accesspage from '../../../common/404';
import Storage from '../../../services/local-store';
import loginSchema from '../../../schema/tvlogin';
import * as R from 'ramda';
import { changeConfirmLocale } from 'antd/lib/modal/locale';
import userTrackService from './../../../services/usertrack-service';

const $ = require('jquery');

class MasterList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            clicked: false,
            slug: null,
            modalVisible: false,
            list: [],
            permissions:{},
            formData: [],
            rowName: null,
            tbody: [],
            roleData:{},
            rid:null,
            changedObj: {},
            queue_list:[],
            counter_data:[],
            permissionsData: [],
            editModalData:null
        };
        this.listRef = React.createRef();
    }
    componentDidMount() {
        //console.log('ste',this.state);
        this.tableHeadrender();
        this.permissions();
        const {slug} = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        //console.log(rid)
        this.setState((state)=>({'rid':rid}));
        //console.log('list',this.props);
        $('.tv-counter-data').css({
            'height': $(window).outerHeight() - 35
        });
        if(slug === 'start-counter'){
            this.counterstart();
        }else{
           
            this.fetchListData(rid);
        }
        setTimeout(function () {
            if (($('.body-container').outerHeight(true) + $('header').outerHeight(true)) > $(window).height()) {
                $('footer').css({'position': 'relative', top: '57px'});
            } else {
                $('footer').css({'position': 'fixed', top: 'unset'});
            }
        }, 100);
    }

    componentWillUnmount() {
        $('footer').css({'position': 'fixed', top: 'unset'});
    }

    componentWillUnmount(){
        //console.log('admin unmount');
        clearInterval(this.interval);
        
    }

    getSnapshotBeforeUpdate(prevProps) {
        return prevProps;
    }

    setModalVisible(modalVisible) {
        
        this.setState((state)=>({modalVisible:modalVisible,editModalData:null}),()=>{
            this.tableHeadrender();
        });
    }

    componentDidUpdate(prevProps, snapshot) {
        const {slug} = this.props.match.params;
        if(slug === 'start-counter'){
        this.interval = setInterval(this.counterstart(), 4000);
        }
        setTimeout(function () {

            if (($('.body-container').outerHeight(true) + $('header').outerHeight(true)) > $(window).height()) {
                $('footer').css({'position': 'relative', top: '57px'});
            } else {
                $('footer').css({'position': 'fixed', top: 'unset'});
            }
        }, 100);
        $('.tv-counter-data').css({'height': $(window).outerHeight() - 35});
        if (snapshot !== null) {
            if (prevProps.match.params.slug !== this.props.match.params.slug) {
                this.setState((state) => ({list: [], formData: [], slug: null}));
                //console.log('update',this.state);
                const params = new URLSearchParams(this.props.location.search);
                const rid = params.get('rid');
                this.setState((state)=>({'rid':rid}));
                this.tableHeadrender();
                this.permissions();
                if(slug === 'start-counter'){
                        this.counterstart()
                }else{
                    this.fetchListData(rid);
                }


                //console.log('listup',this.props);
            }
        }
    }
    permissions(){
        //console.log('menu');
       
        //console.log('list',this.state);

    }

    counterstart(){
        const tvToken = Storage.get('tv_display_id') 
        const {getTvCounter} = networkList;
        if(tvToken !== null && tvToken !== undefined){
        postService(getTvCounter, 'POST', {data:{"tv_display_id":JSON.parse(tvToken)}}).then((res) => {
            if (res) {
                //console.log(res);
               // Storage.store('tvtoken', res.token);
                this.setState((state) => ({counter_data: res.data.sort(function(a, b){
                    if(a.queue_list_id < b.queue_list_id) { return -1; }
                    if(a.queue_list_id > b.queue_list_id) { return 1; }
                    return 0;
                })}));
            }
        });
    }
    }

    login() {
        
        const {tvDisplayLogin} = networkList;
        var validData = [];
        loginSchema
            .feilds
            .filter((data, key) => {
                if (data['element'] === 'input' && !data.valid && data.required) {
                    validData.push(false)
                    this.validateFeilds(data);
                }
            })
        if (!validData.includes(false)) {
            let usernameobj = R.find(R.propEq('name', 'tv_display_name'))(loginSchema.feilds);
            let passwordobj = R.find(R.propEq('name', 'password'))(loginSchema.feilds);
                if (!R.isNil(usernameobj) && !R.isNil(passwordobj)) {
                    let obj = {
                        "tv_display_name": usernameobj.value,
                        "password": passwordobj.value
                    }
            postService(tvDisplayLogin, 'POST', {data:obj}).then((res) => {
                if (res) {
                    //console.log(res);
                   // Storage.store('tvtoken', res.token);
                    Storage.store('tv_display_id', res.rows[0].tv_display_id);
                    this.setState((state) => ({date: new Date()}));
                }
            });
        }
        }
    }


    validateFeilds(event) {
        loginSchema
            .feilds
            .filter((feild, fkey) => {
                if (feild['element'] === 'input' && feild['name'] === event.name) {
                    loginSchema.feilds[fkey].errors = [];
                    if (feild['rules'].length > 0) {
                        feild['rules'].map((rule, rkey) => {
                            if (typeof rule.test === 'function') {
                                if (event.value !== null && rule.test(event.value)) {} else {
                                    loginSchema
                                        .feilds[fkey]
                                        .errors
                                        .push({message: rule.message});
                                }
                            }
                            if (rule.test instanceof RegExp) {
                                if (event.value !== null && rule.test.test(event.value)) {} else {
                                    loginSchema
                                        .feilds[fkey]
                                        .errors
                                        .push({message: rule.message});
                                }
                            }
                        })
                        if (feild.errors.length !== 0) {
                            this.setState((state) => ({
                                [event.name]: event.value
                            }));
                            loginSchema.feilds[fkey].valid = false;
                        } else {
                            this.setState((state) => ({
                                [event.name]: event.value
                            }));
                            loginSchema.feilds[fkey].valid = true;
                        }

                    } else {
                        this.setState((state) => ({
                            [event.name]: event.value
                        }));
                        loginSchema.feilds[fkey].valid = true;
                    }

                }
            });
    }

    forminputChangedState(event) {
        if(event.enter){
            this.login(event);
        }else
        {
            this.validateFeilds(event);
        }
    }

    onSwitcjChange(checked, id) {
        //console.log(checked, id);
    }

    inputChangedState(event) {

        if (event.name === 'roleName') {
            //console.log(event);
            const {checkDuplicateRole} = networkList;
            postService(checkDuplicateRole, 'POST', {'rolename': event.value}).then(res => {
                //console.log(res);
                if (res.data === '1') {
                    this
                        .state
                        .formData
                        .map((form, key) => {

                            if (form['name'] === event['name']) {
                                this.state.formData[key]['errors'] = [];
                                this
                                .state
                                .formData[key]['valid'] = false;
                                this
                                .state
                                .formData[key]['value'] = null;
                                this
                                    .state
                                    .formData[key]['errors']
                                    .push({'id': key, 'message': 'Role Name already exists'});
                            }
                        })
                    this.setState({'rowName': null});
                } else {
                    this
                        .state
                        .formData
                        .map((form, key) => {

                            if (form['name'] === event['name']) {
                                this
                                .state
                                .formData[key]['valid'] = true;
                                this
                                .state
                                .formData[key]['value'] = event.value;
                                this.state.formData[key]['errors'] = [];
                            }
                        })
                    this.setState({'rowName': event.value});
                }
            });

        }
    }

    addnewRole() {
        const {createNewRole} = networkList;

        let permissionData = this.state.permissionsData;
        permissionData.map((data, key) => {
            let submenuView = [];
            if (data.submenu.length === 0) {
                Object
                    .keys(data.permissions)
                    .map(okey => {
                        if (data['permissions'][okey] === '0' || data['permissions'][okey] === '1') {
                            permissionData[key]['permissions'][okey] = false;
                        }
                    })
            }
            if (data.submenu.length !== 0) {

                data
                    .submenu
                    .map((smenu, skey) => {
                        Object
                            .keys(smenu.permissions)
                            .map(okey => {
                                if (smenu['permissions'][okey] === '0' || smenu['permissions'][okey] === '1') {
                                    permissionData[key]['submenu'][skey]['permissions'][okey] = false;
                                }
                            })

                        if (smenu['permissions']['view']) {
                            submenuView.push(true);
                        } else {
                            submenuView.push(false);
                        }
                    })
                if (submenuView.includes(true)) {
                    Object
                        .keys(data.permissions)
                        .map(okey => {
                            if (data['permissions'][okey] === '0' || data['permissions'][okey] === '1') {
                                permissionData[key]['permissions'][okey] = true;
                            }
                        })
                } else {
                    Object
                        .keys(data.permissions)
                        .map(okey => {
                            if (data['permissions'][okey] === '0' || data['permissions'][okey] === '1') {
                                permissionData[key]['permissions'][okey] = false;
                            }
                        })
                }
            }
        });

        this.validateFormFeilds();

        if(this.state['rowName'] !== null && this.state['rowName'] !== '' && this.state['rowName'] !== undefined){
            let data = {
                'role_name': this.state['rowName'],
                'data': permissionData
            }

          

            postService(createNewRole, 'POST', {'data': data}).then(res => {
                if (res.status) {
                    this
                        .props
                        .history
                        .push('/settings/roles');
                } else {
                    alert('data not inserted');
                };
            })
        }else{
            window.scrollTo(0, 0);
            // Modal.error({
            //     title: 'This is an error message',
            //     content: 'Please fill all mandatory feilds',
            //   });
              
        }
        
    }

    validateFormFeilds(){
        
        this.state.formData.map((feild,key)=>{
            if(feild['required']){
                if(feild['errors'].length === 0){
                    feild.rules.map((rule,rkey)=>{
                       if(typeof rule.test === 'function'){
                           if(feild['value'] !== null && feild['value'] !== undefined && rule.test(feild['value'])){
                           }else{
                            window.scrollTo(0, 0);
                            this.state.formData[key]['errors'].push({message: rule.message});
                           }
                           
                       }
                    })
                }
            }
        })
        this.setState((state)=>({'date': new Date()}));
        //console.log('addrole validate',roleForm.feilds);
    }

    gotoAddRole() {
        this
            .props
            .history
            .push('/settings/addrole');
    }
    gotoAddusers() {
        this
            .props
            .history
            .push('/settings/adduser');
    }
    permissionsTablechange(evt) {
        //console.log(evt)
        const {menuList} = this.props;
        menuList.map((menu,key)=>{
            if(menu['submenu'].length === 0){
                if(evt['id'] === "edit"){
                  evt = {id: "view", value: true, parrentMode: evt.parrentMode , parrentName: evt.parrentMode}
                }
            }
        })
        this.setState((state) => ({'permissionsData': evt}));
    }


    editclick(data){
        const {slug} = this.props.match.params;
        if(slug === 'roles'){
            this
            .props
            .history
            .push('/settings/editrole?rid='+data['id']);
        }
        if(slug === 'users'){
            this
            .props
            .history
            .push('/settings/edituser?rid='+data['id']);
        }
        if(slug === 'tv-displays'){
            this
            .props
            .history
            .push('/settings/edittvscreen?rid='+data['tv_display_id']);
        }
        if(slug === 'radiologist'){
            this
            .props
            .history
            .push('/settings/editradiologist?rid='+data['doctor_id']);
        }
        if(slug === 'units' || slug === 'departments' || slug === 'services' || slug === 'doctors' || slug === 'service-group'){
            this.setState((state)=>({editModalData:data}));
            this.tableHeadrender(data);
            this.setState((state)=>({modalVisible:true}));
        }
    }

    viewclick(rid){
        const {slug} = this.props.match.params;
        if(slug === 'roles'){
            this
            .props
            .history
            .push('/settings/viewrole?rid='+rid);
        }
    }

    handleChange(ele) {
        //console.log(ele);
        const {checkDuplicateUser, checkDuplicateTvDisplay} = networkList;
        const {slug} = this.props.match.params;
        //console.log(slug);

        if (slug === 'edituser') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;
                        if (data['name'] === 'userName') {
                            data['errors'] = [];
                            postService(checkDuplicateUser, 'POST', {"username": ele.value}).then(res => {
                                if (res.data === '0') {
                                    //console.log(res);
                                    data['value'] = ele.value;
                                    data['valid'] = true;
                                    data['errors'] = [];

                                } else {
                                    data['value'] = null;
                                    data['valid'] = true;
                                    data['errors'].push({'id': 1, 'message': 'User Already exists'});
                                }
                                this.state.formData[key] = data;
                            })
                        }
                        //this.setState((state)=>({state.formData['']}))
                        if (data['name'] === 'accessLevel') {
                            if (ele['value'] === 2) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 3) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 4) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 1) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                        }
                    }
                });

            this.setState((state) => ({date: new Date()}));
        }

        if (slug === 'adduser') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;
                        if (data['name'] === 'userName') {
                            data['errors'] = [];
                            postService(checkDuplicateUser, 'POST', {"username": ele.value}).then(res => {
                                if (res.data === '0') {
                                    //console.log(res);
                                    data['value'] = ele.value;
                                    data['valid'] = true;
                                    data['errors'] = [];

                                } else {
                                    data['value'] = null;
                                    data['valid'] = true;
                                    data['errors'].push({'id': 1, 'message': 'User Already exists'});
                                }
                                this.state.formData[key] = data;
                            })
                        }
                        //this.setState((state)=>({state.formData['']}))
                        if (data['name'] === 'accessLevel') {
                            if (ele['value'] === 2) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 3) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 4) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                            if (ele['value'] === 1) {
                                this
                                    .state
                                    .formData
                                    .map((ddata, dkey) => {
                                        if (ddata['name'] === 'unit') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'department') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }
                                        if (ddata['name'] === 'service') {
                                            ddata['disable'] = true;
                                            ddata['value'] = null;
                                            ddata['valid'] = false;
                                            this.state.formData[dkey] = ddata;
                                        }

                                    })
                            }
                        }
                    }
                });

            this.setState((state) => ({date: new Date()}));
        }

        if (slug === 'addtvscreen') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            
           
            
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;

                        if(ele['name'] === 'queues'){
                            if(this.state.queue_list.length !=0){

                                var state = this.state;
                                                                
                                function add(arr, name) {
                                    const { length } = arr;
                                    const id = length + 1;
                                    const found = arr.some(el => el.qListId === name);
                                     if (!found) state.queue_list.push({'qListId':ele['value'],'qListName':null});
                                    return arr;
                                }
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                add(this.state.queue_list, ele['value']);

                    
                            }else{
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                this.state.queue_list.push({'qListId':ele['value'],'qListName':null});
                            }
                        }



                        if (data['name'] === 'displayName') {
                            data['errors'] = [];
                            postService(checkDuplicateTvDisplay, 'POST', {"displayName": ele.value}).then(res => {
                                if (res.data === '0') {
                                    //console.log(res);
                                    data['value'] = ele.value;
                                    data['valid'] = true;
                                    data['errors'] = [];
                                } else {
                                    data['value'] = null;
                                    data['valid'] = false;
                                    data['errors'].push({'id': 1, 'message': 'User Already exists'});
                                }
                                this.state.formData[key] = data;
                            })
                        }

                        if (data['name'] === 'unit') {
                            data['disable'] = false;
                            data['value'] = ele.value;
                            data['valid'] = true;

                            this
                                .state
                                .formData
                                .map((ddata, dkey) => {
                                    if (ddata['name'] === 'department') {
                                        ddata['disable'] = false;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }
                                    if (ddata['name'] === 'service') {
                                        ddata['disable'] = true;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }
                                    if (ddata['name'] === 'queues') {
                                        ddata['disable'] = false;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }

                                })

                            this.state.formData[key] = data;
                        }
                        if (data['name'] === 'department') {
                            data['disable'] = false;
                            data['value'] = ele.value;
                            data['valid'] = true;
                            this.state.formData[key] = data;

                            this
                                .state
                                .formData
                                .map((ddata, dkey) => {

                                    if (ddata['name'] === 'service') {
                                        ddata['disable'] = false;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }
                                    if (ddata['name'] === 'queues') {
                                        ddata['disable'] = false;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }

                                })
                        }
                        if (data['name'] === 'service') {
                            data['disable'] = false;
                            data['value'] = ele.value;
                            data['valid'] = true;
                            this.state.formData[key] = data;
                            this
                                .state
                                .formData
                                .map((ddata, dkey) => {

                                    if (ddata['name'] === 'queues') {
                                        ddata['disable'] = false;
                                        ddata['value'] = null;
                                        ddata['valid'] = false;
                                        this.state.formData[dkey] = ddata;
                                    }

                                })
                        }

                    }
                });

            this.setState((state) => ({date: new Date()}));
        }



        if (slug === 'edittvscreen') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            
           
            
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;

                        if(ele['name'] === 'queues'){
                            if(this.state.queue_list.length !=0){

                                var state = this.state;
                                                                
                                function add(arr, name) {
                                    const { length } = arr;
                                    const id = length + 1;
                                    const found = arr.some(el => el.qListId === name);
                                    if (!found) state.queue_list.push({'qListId':ele['value'],'qListName':null});
                                    return arr;
                                }
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                add(this.state.queue_list, ele['value']);

                    
                            }else{
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                this.state.queue_list.push({'qListId':ele['value'],'qListName':ele['value']});
                            }
                        }



                        // if (data['name'] === 'displayName') {
                        //     data['errors'] = [];
                        //     postService(checkDuplicateTvDisplay, 'POST', {"displayName": ele.value}).then(res => {
                        //         if (res.data === '0') {
                        //             //console.log(res);
                        //             data['value'] = ele.value;
                        //             data['valid'] = true;
                        //             data['errors'] = [];
                        //         } else {
                        //             data['value'] = null;
                        //             data['valid'] = false;
                        //             data['errors'].push({'id': 1, 'message': 'User Already exists'});
                        //         }
                        //         this.state.formData[key] = data;
                        //     })
                        // }

                        
                    }
                });

            this.setState((state) => ({date: new Date()}));
        }


        if (slug === 'addradiologist') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            
           
            
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;


                        // if (data['name'] === 'displayName') {
                        //     data['errors'] = [];
                        //     postService(checkDuplicateTvDisplay, 'POST', {"displayName": ele.value}).then(res => {
                        //         if (res.data === '0') {
                        //             //console.log(res);
                        //             data['value'] = ele.value;
                        //             data['valid'] = true;
                        //             data['errors'] = [];
                        //         } else {
                        //             data['value'] = null;
                        //             data['valid'] = false;
                        //             data['errors'].push({'id': 1, 'message': 'User Already exists'});
                        //         }
                        //         this.state.formData[key] = data;
                        //     })
                        // }

                        if(ele['name'] === 'new_queues'){
                            if(this.state.queue_list.length !=0){

                                var state = this.state;
                                                                
                                function add(arr, name) {
                                    const { length } = arr;
                                    const id = length + 1;
                                    const found = arr.some(el => el.qListId === name);
                                     if (!found) state.queue_list.push({'qListId':ele['value'],'qListname':ele['text']});
                                    return arr;
                                }
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                add(this.state.queue_list, ele['value']);

                    
                            }else{
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                this.state.queue_list.push({'qListId':ele['value'],'qListname':ele['text']});
                            }
                        }



                

                        if (data['name'] === 'unit') {
                            data['disable'] = false;
                            data['value'] = ele.value;
                            data['valid'] = true;
                        }
                       

                    }
                });

            this.setState((state) => ({date: new Date()}));
        }

        if (slug === 'editradiologist') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'department') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'service') {
                this.state.changedObj = ele;
            }
            
           
            
            this
                .state
                .formData
                .map((data, key) => {
                    //console.log(data['name'] === ele['name'])
                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['valid'] = true;
                        this.state.formData[key] = data;


                        // if (data['name'] === 'displayName') {
                        //     data['errors'] = [];
                        //     postService(checkDuplicateTvDisplay, 'POST', {"displayName": ele.value}).then(res => {
                        //         if (res.data === '0') {
                        //             //console.log(res);
                        //             data['value'] = ele.value;
                        //             data['valid'] = true;
                        //             data['errors'] = [];
                        //         } else {
                        //             data['value'] = null;
                        //             data['valid'] = false;
                        //             data['errors'].push({'id': 1, 'message': 'User Already exists'});
                        //         }
                        //         this.state.formData[key] = data;
                        //     })
                        // }

                        if(ele['name'] === 'new_queues'){
                            if(this.state.queue_list.length !=0){

                                var state = this.state;
                                                                
                                function add(arr, name) {
                                    const { length } = arr;
                                    const id = length + 1;
                                    const found = arr.some(el => el.qListId === name);
                                     if (!found) state.queue_list.push({'qListId':ele['value'],'qListname':ele['text']});
                                    return arr;
                                }
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                add(this.state.queue_list, ele['value']);

                    
                            }else{
                                this.state.formData[key]['valid'] = false;
                                this.state.formData[key]['value'] = null;
                                this.state.queue_list.push({'qListId':ele['value'],'qListname':ele['text']});
                            }
                        }



                

                        if (data['name'] === 'unit') {
                            data['disable'] = false;
                            data['value'] = ele.value;
                            data['valid'] = true;
                        }
                       

                    }
                });

            this.setState((state) => ({date: new Date()}));
        }



    }





    addUser() {
        const {updateQueueDoctor,updateUserDetailsById,createUser,addTvDisplay,updateTvDisplay,addQueueDoctor} = networkList;
        const {slug} = this.props.match.params;
        var formFeilds = this.state.formData;
      let errors = this.validateModalFeilds(formFeilds)
      
        if (!errors.includes(false)) {
           
        if(slug === 'edittvscreen'){
            var data = this.state.tbody[0];
            data["queue_list"] = this.state.queue_list;
            this
                .state
                .formData
                .map((sva, key) => {
                    if (sva['name'] === 'displayName') {
                        data['display_name'] = sva['value'];
                    }
                    if (sva['name'] === 'password') {
                        data['password'] = sva['value'];
                    }
                })

          
            postService(updateTvDisplay, 'POST', {"data": data}).then(res => {

                var props = this.props
                if (res.status) {
                    Modal.success({
                        title: 'Success',
                        content: 'TV Updated Created',
                        onOk() {
                            props
                            .history
                            .push('/tv-settings/tv-displays');
                        },
                        maskClosable:false
                    });
                    
                } else {
                    Modal.error({
                        title: 'Error!',
                        content: res.message,
                        maskClosable:false
                    });
                }

                
            })  
        }



        if(slug === 'edituser'){
            var data = this.state.tbody;
            this
                .state
                .formData
                .map((sva, key) => {
                    if (sva['name'] === 'userName') {
                        data['username'] = sva['value'];
                    }
                    if (sva['name'] === 'password') {
                        data['password'] = sva['value'];
                    }
                    if (sva['name'] === 'role') {
                        data['roleid'] = sva['value'];
                    }
                })

            //console.log(data);  
            postService(updateUserDetailsById, 'POST', {"data": data}).then(res => {

                var props = this.props
                if (res.status) {
                    Modal.success({
                        title: 'Success',
                        content: 'Queue Sucessfully Created',
                        onOk() {
                            props
                            .history
                            .push('/settings/users');
                        },
                        maskClosable:false
                    });
                    
                } else {
                    Modal.error({
                        title: 'Error!',
                        content: res.message,
                        maskClosable:false
                    });
                }

                
            })  
        }

        if (slug === 'addtvscreen'){
           
        var data = {
    
        "display_name": null,
        "password": null,
        "queue_list":this.state.queue_list}

        this
        .state
        .formData
        .map((sva, key) => {
            if (sva['name'] === 'displayName') {
                data['display_name'] = sva['value'];
            }
            if (sva['name'] === 'password') {
                data['password'] = sva['value'];
            }
            
            if (sva['name'] === 'unit') {
                data['unit'] = sva['value'];
            }
            if (sva['name'] === 'department') {
                data['department'] = sva['value'];
            }
            if (sva['name'] === 'service') {
                data['service'] = sva['value'];
            }
        })
        //console.log(data);
        postService(addTvDisplay, 'POST', {"data": data}).then(res => {

            var props = this.props
            if (res.status) {
                Modal.success({
                    title: 'Success',
                    content: 'TV Sucessfully Created',
                    onOk() {
                        props
                        .history
                        .push('/tv-settings/tv-displays');
                    },
                    maskClosable:false
                  });
                
            } else {
                Modal.error({
                    title: 'Error!',
                    content: res.message,
                    maskClosable:false
                  });
            }

            
        })

            //console.log('save tv screen', data);

           
        }
        if (slug === 'adduser'){
        var data = {
            "name": "1",
            "password": "1",
            "role_id": "1",
            "access_type": "0",
            "unit": "0",
            "department": "0",
            "service": "0"
        }
        this
            .state
            .formData
            .map((sva, key) => {
                if (sva['name'] === 'userName') {
                    data['name'] = sva['value'];
                }
                if (sva['name'] === 'password') {
                    data['password'] = sva['value'];
                }
                if (sva['name'] === 'role') {
                    data['role_id'] = sva['value'];
                }
                if (sva['name'] === 'accessLevel') {
                    data['access_type'] = sva['value'];
                }
                if (sva['name'] === 'unit') {
                    data['unit'] = sva['value'];
                }
                if (sva['name'] === 'department') {
                    data['department'] = sva['value'];
                }
                if (sva['name'] === 'service') {
                    data['service'] = sva['value'];
                }
            })
            //console.log(data);
            postService(createUser, 'POST', {"data": data}).then(res => {
                if (res.status) {
                    this
                        .props
                        .history
                        .push('/settings/users');
                } else {
                    alert('Data not inserted');
                }
            })
        }

        if (slug === 'addradiologist'){
            var data = {
                "username": null,
                "password": null,
                "role": "RL_ijmN",
                "accesslevel": "2",
                "queue_list": []
            }
            this
                .state
                .formData
                .map((sva, key) => {
                    if (sva['name'] === 'username') {
                        data['username'] = sva['value'];
                    }
                    if (sva['name'] === 'password') {
                        data['password'] = sva['value'];
                    }
                    if (sva['name'] === 'unit') {
                        data['unit'] = sva['value'];
                    }
                    if (sva['name'] === 'new_queues') {
                        let obj ={};
                        let newArry = [];
                        obj['qListId'] = newArry;
                        this.state.queue_list.map((data)=>{
                            newArry.push(data['qListId']);
                        })
                        data['queue_list'] = obj;
                    }
                })
               
               
                postService(addQueueDoctor, 'POST', {"data": data}).then(res => {
                    if (res.status) {
                        this
                            .props
                            .history
                            .push('/settings/radiologist');
                    } else {
                        alert('Data not inserted');
                    }
                })
            }


            if (slug === 'editradiologist'){
                
                var tbody = this.state.tbody[0];
                let data = {"role": "RL_ijmN",
                "accesslevel": "2",};
                this
                    .state
                    .formData
                    .map((sva, key) => {
                        if (sva['name'] === 'username') {
                            data['username'] = sva['value'];
                        }
                        if (sva['name'] === 'password') {
                            data['password'] = sva['value'];
                        }
                        if (sva['name'] === 'unit') {
                            data['unit'] = sva['value'];
                        }
                        if (sva['name'] === 'new_queues') {
                            let obj ={};
                            let newArry = [];
                            obj['qListId'] = newArry;
                            this.state.queue_list.map((data)=>{
                                newArry.push(data['qListId']);
                            })
                            data['queue_list'] = obj;
                        }
                    })
                    data['doctor_id'] = tbody['doctor_id'];
                    data['doctor_user_id'] = tbody['doctor_user_id']
                    console.clear();
                  
                    postService(updateQueueDoctor, 'POST', {"data": data}).then(res => {
                        if (res.status) {
                            this
                                .props
                                .history
                                .push('/settings/radiologist');
                        } else {
                            alert('Data not inserted');
                        }
                    })
                }
    }
    }
    gotoaddTvScreen() {
        this.state.queue_list=[];
        this
            .props
            .history
            .push('/settings/addtvscreen');
    }

    gotoaddradiologist(){
        this.state.queue_list=[];
        this
            .props
            .history
            .push('/settings/addradiologist');
    }

    editfeilds(data){
       
        this.setState((state)=>({roleData:data.roledata}))
    }


    tableHeadrender(data) {
        const {slug} = this.props.match.params;
        let obj = null;
        const {menuList} = this.props;
        menuList.map(data => {
            var subData = data
                .submenu
                .find(o => o.route === slug);
            if (subData != undefined) {
                obj = subData;
            }
        })
        let dataform = null
       console.log(obj); 
        if (obj !== undefined) {
            switch (slug) {
                case 'units':
                    dataform = $.extend(true, {}, unitForm);
                    if(data !== null && data !== undefined){
                        dataform.feilds.map((dataf,key)=>{
                            if(dataf['element'] === 'input'){
                                 Object.keys(data).map(Okey=>{
                                     if(dataf['name'] === Okey){
                                        dataform.feilds[key]['value'] = data[Okey];
                                        dataform.feilds[key]['valid'] = true;
                                     }
                                 })
                            }
                        });
                    }
                    console.clear();
                    //console.log(dataform);
                    this.setState((state) => ({list: unitList.tableList, formData: dataform.feilds, slug: 'Unit',slugText:'Unit'}));
                    break;
                case 'departments':
                        console.clear();
                    //console.log(data);
                    
                        dataform = $.extend(true, {}, departmentForm);
                        if(data !== null && data !== undefined){
                            dataform.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                     Object.keys(data).map(Okey=>{
                                         if(dataf['name'] === Okey){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                     })
                                }
                            });
                        }
                        
                       
                        //console.log(dataform);
                    this.setState((state) => ({list: departmentList.tableList, formData: dataform.feilds, slug: 'Department',slugText:'Department'}));
                    break;

                case 'service-group':
                       
                        dataform = $.extend(true, {}, serviceGroupForm);
                        if(data !== null && data !== undefined){
                            dataform.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                     Object.keys(data).map(Okey=>{
                                         if(dataf['name'] === Okey){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                         if(Okey === 'department_id' && dataf['name'] === 'department'){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                     })
                                }
                            });
                        }
                        console.clear();
                        //console.log(data);
                        //console.log(dataform);
                    this.setState((state) => ({list: serviceGroupList.tableList, formData: dataform.feilds, slug: 'service-group',slugText:'Service Group'}));
                    break;   
                case 'services':
                        dataform = $.extend(true, {}, serviceForm);
                        if(data !== null && data !== undefined){
                            dataform.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                     Object.keys(data).map(Okey=>{
                                         if(dataf['name'] === Okey){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                         if(Okey === 'department_id' && dataf['name'] === 'department'){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                     })
                                }
                            });
                        }
                    this.setState((state) => ({list: serviceList.tableList, formData: dataform.feilds, slug: 'Service',slugText:'Service'}));
                    break;
                case 'doctors':

                        dataform = $.extend(true, {}, doctorForm);
                        if(data !== null && data !== undefined){
                            dataform.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                     Object.keys(data).map(Okey=>{
                                         if(dataf['name'] === Okey){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                         if(Okey === 'department_id' && dataf['name'] === 'department'){
                                            dataform.feilds[key]['value'] = data[Okey];
                                            dataform.feilds[key]['valid'] = true;
                                         }
                                     })
                                }
                            });
                        }
                        console.clear();
                        //console.log(data);
                        //console.log(dataform);
                    this.setState((state) => ({list: doctorList.tableList, formData: dataform.feilds, slug: 'Doctor',slugText:'Doctor'}));
                    break;


                    case 'radiologist':

                    this.setState((state) => ({list: QueuedoctorList.tableList, formData: QueuedoctorForm.feilds, slug: 'radiologist',slugText:'Radiologist'}));
                    break;

                    case 'addradiologist':

                        dataform = $.extend(true, {}, QueuedoctorForm);
                        
                    this.setState((state) => ({list: QueuedoctorList.tableList, formData: dataform.feilds, slug: 'addradiologist',slugText:'Add Radiologist'}));
                    break;

                    
                case 'users':
                    this.setState((state) => ({list: userList.tableList, formData: userForm.feilds, slug: 'users',slugText:'User'}));
                    break;
                    case 'edituser':
                        let edituserForm = $.extend(true, {}, userForm);

                        if(data !== null && data !== undefined){
                            edituserForm.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                    
                                         if(dataf['name'] === "userName"){
                                            edituserForm.feilds[key]['value'] = data['username'];
                                            edituserForm.feilds[key]['valid'] = true;
                                         }
                                         if(dataf['name'] === "password"){
                                            edituserForm.feilds[key]['value'] = data['password'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['input_type'] = 'text';
                                         }
                                         if(dataf['name'] === "role"){
                                            edituserForm.feilds[key]['value'] = data['roleid'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['text'] = data['rolename'];
                                           
                                         }

                                         if(dataf['name'] === "accessLevel"){
                                            edituserForm.feilds[key]['value'] = data['fk_access_level_id'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['disable'] = true;
                                            edituserForm.feilds[key]['text'] = data['access_name'];
                                         }


                                         if(dataf['name'] === "unit"){
                                            edituserForm.feilds[key]['value'] = data['unitid'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['disable'] = true;
                                            edituserForm.feilds[key]['text'] = data['unitname'];
                                         }

                                         if(dataf['name'] === "department"){
                                            edituserForm.feilds[key]['value'] = data['departmentid'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['disable'] = true;
                                            edituserForm.feilds[key]['text'] = data['departmentname'];
                                         }

                                         if(dataf['name'] === "service"){
                                            edituserForm.feilds[key]['value'] = data['service_group_id'];
                                            edituserForm.feilds[key]['valid'] = true;
                                            edituserForm.feilds[key]['disable'] = true;
                                            edituserForm.feilds[key]['text'] = data['service_group_name'];
                                         }
                                }
                            });
                        }
                        console.clear();
                        //console.log(data);
                        //console.log(edituserForm);
                        this.setState((state) => ({list: roleList.tableList, formData: edituserForm.feilds, slug: 'editUser'}));
                        break;

                    
                case 'adduser':
                        let adduserForm = $.extend(true, {}, userForm);
                    this.setState((state) => ({list: userList.tableList, formData: adduserForm.feilds, slug: 'addUser'}));
                    break;
                case 'roles':
                    let roleFormF = $.extend(true, {}, roleForm);
                    this.setState((state) => ({list: roleList.tableList, formData: roleFormF.feilds, slug: 'roles',slugText:'Role'}));
                    break;
                case 'addrole':
                    let addroleForm = $.extend(true, {}, roleForm);
                    this.setState((state) => ({list: roleList.tableList, formData: addroleForm.feilds, slug: 'addrole'}));
                    break;
                    case 'editrole':
                        let editroleForm = $.extend(true, {}, roleForm);
                        this.setState((state) => ({list: roleList.tableList, formData: editroleForm.feilds, slug: 'editrole'}));
                        break;
                        case 'viewrole':
                                let viewroleForm = $.extend(true, {}, roleForm);
                                this.setState((state) => ({list: roleList.tableList, formData: viewroleForm.feilds, slug: 'viewrole'}));
                                break;    
                case 'tv-displays':
                    this.setState((state) => ({list: tvList.tableList, formData: tvForm.feilds, slug: 'tvscreen',slugText:'TV Screen'}));
                    break;
                case 'addtvscreen':
                        let addtvForm = $.extend(true, {}, tvForm);
                        this.setState((state) => ({list: tvList.tableList, formData: addtvForm.feilds, slug: 'addtvscreen'}));
                        break;
                        case 'edittvscreen':    
                        let edittvForm = $.extend(true, {}, tvForm);
                        console.clear();
                        if(data !== null && data !== undefined){
                            //console.log(data);
                            edittvForm.feilds.map((dataf,key)=>{
                                if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                    let edata = data[0];
                                    if(dataf.name === 'displayName'){
                                            edittvForm.feilds[key]['value'] = edata.display_name;
                                            edittvForm.feilds[key]['valid'] = true;
                                    }
                                    if(dataf.name === 'unit'){
                                        edittvForm.feilds[key]['value'] = edata.unit;
                                        edittvForm.feilds[key]['valid'] = true;
                                        edittvForm.feilds[key]['disable'] = true;
                                        edittvForm.feilds[key]['text'] = edata.unit_name;
                                    }

                                    if(dataf.name === 'password'){
                                        edittvForm.feilds[key]['value'] = edata.password;
                                        edittvForm.feilds[key]['valid'] = true;
                                        edittvForm.feilds[key]['disable'] = false;
                                        edittvForm.feilds[key]['input_type'] = 'text';
                                    }
                                    
                                    if(dataf.name === 'department'){
                                        edittvForm.feilds[key]['value'] = edata.department;
                                        edittvForm.feilds[key]['valid'] = true;
                                        edittvForm.feilds[key]['disable'] = true;
                                        edittvForm.feilds[key]['text'] = edata.department_name;
                                    }

                                    if(dataf.name === 'service'){
                                        edittvForm.feilds[key]['value'] = edata.service;
                                        edittvForm.feilds[key]['valid'] = true;
                                        edittvForm.feilds[key]['disable'] = true;
                                        edittvForm.feilds[key]['text'] = edata.service_group_name;
                                    }
                                    if(dataf.name === 'queues'){
                                        edittvForm.feilds[key]['valid'] = true;
                                        edittvForm.feilds[key]['value'] = '';
                                        edittvForm.feilds[key]['disable'] = false;
                                        let queue_list_data = [];
                                        edata.queue_list.map(qlData=>{
                                            queue_list_data.push({'qListId':qlData.queue_list_id,'qListName':qlData.queue_list_name});
                                        })
                                        

                                        this.setState((state)=>({queue_list:queue_list_data}))
                                    }
                                    
                                }
                            });
                            //console.log(edittvForm);
                        }
                        
               

                    this.setState((state) => ({list: tvList.tableList, formData: edittvForm.feilds, slug: 'edittvscreen'}));
                    break;
                    case 'editradiologist':    
                    let readioForm = $.extend(true, {}, QueuedoctorForm);
                    console.clear();
                    if(data !== null && data !== undefined){
                        //console.log(data);
                        readioForm.feilds.map((dataf,key)=>{
                            if(dataf['element'] === 'input' || dataf['element'] === 'select2'){
                                let edata = data[0];
                                if(dataf.name === 'username'){
                                        readioForm.feilds[key]['value'] = edata.username;
                                        readioForm.feilds[key]['valid'] = true;
                                        readioForm.feilds[key]['disable'] = true;
                                }
                                if(dataf.name === 'unit'){
                                    readioForm.feilds[key]['value'] = edata.unit;
                                    readioForm.feilds[key]['valid'] = true;
                                    readioForm.feilds[key]['disable'] = true;
                                    readioForm.feilds[key]['text'] = edata.unit_name;
                                }
    
                                if(dataf.name === 'password'){
                                    readioForm.feilds[key]['value'] = edata.password;
                                    readioForm.feilds[key]['valid'] = true;
                                    readioForm.feilds[key]['disable'] = true;
                                    readioForm.feilds[key]['input_type'] = 'password';
                                }
                                
                                if(dataf.name === 'new_queues'){
                                    readioForm.feilds[key]['valid'] = true;
                                    readioForm.feilds[key]['value'] = '';
                                    readioForm.feilds[key]['disable'] = false;
                                    let queue_list_data = [];
                                    edata.queue_list.map(qlData=>{
                                        queue_list_data.push({'qListId':qlData.queue_list_id,'qListName':qlData.queue_list_name});
                                    })
                                    
                                    this.setState((state)=>({queue_list:queue_list_data}))
                                }
                                
                            }
                        });
                        //console.log(readioForm);
                    }
                    
                   
    
                        this.setState((state) => ({list: tvList.tableList, formData: readioForm.feilds, slug: 'editradiologist'}));
                        break;


                case 'start-counter':
                    this.setState((state) => ({list: tvList.tableList, formData: tvForm.feilds, slug: 'tvcounter'}));
                    break;

                default:
                    this.setState((state) => ({list: [], formData: [], slug: null}));
                    break;
            }
        } else {
            this.setState((state) => ({list: [], formData: [], slug: null}));
        }
    }

    fetchListData(rid) {
        const {slug} = this.props.match.params;
        //const rid = this.state.rid;
        this.setState((state) => ({tbody: []}));
        //console.log(rid);
        const {getQueueDoctorById,getAllDoctorsDisplays,getUserDetailsById,getTvById,getMasterServicesList,getDoctorsList,getServicesList,getRolesList, getUsersList, getTvDisplays,master_unit,getDepartmentsList,getServicesBasedOnUserId} = networkList;
        if (slug === 'roles') {
            postService(getRolesList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }
        if (slug === 'edituser' && rid !== 'null') {
            postService(getUserDetailsById, 'POST', { "data": {"id":rid}}).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data[0]}));
                    this.tableHeadrender(res.data[0]);
                }
            })
        }

        if (slug === 'edittvscreen' && rid !== 'null'  && rid !== null) {
            postService(getTvById, 'POST', {'data':{'tv_display_id':rid}}).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                    this.tableHeadrender(res.data);
                }
            })
        }


        if (slug === 'editradiologist' && rid !== 'null'  && rid !== null) {
            postService(getQueueDoctorById, 'POST', {'data':{'doctor_id':rid}}).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                    this.tableHeadrender(res.data);
                }
            })
        }
        
       

        if (slug === 'users') {
            postService(getUsersList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'tv-displays') {
            postService(getTvDisplays, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'units') {
            postService(master_unit, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }
        if (slug === 'departments') {
            postService(getDepartmentsList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'service-group') {
            postService(getServicesList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'services') {
            postService(getMasterServicesList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'doctors') {

            postService(getDoctorsList, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        if (slug === 'radiologist') {
            postService(getAllDoctorsDisplays, 'GET', null).then(res => {
                if (res.status) {
                    this.setState((state) => ({tbody: res.data}));
                }
            })
        }

        
    }


    createData(){
        var formFeilds = this.state.formData;
        let errors = this.validateModalFeilds(formFeilds)
        const {slug} = this.props.match.params;
        const {createMasterService,createUnit,createDepartment,createService,createDoctor} = networkList;

        if (!errors.includes(false)) {
            let payload= {};
            formFeilds.map(data=>{
                if(data['element']=== 'input' || data['element']=== 'select2'){
                    if(data['name'] === 'department'){
                        payload['departmentId'] = data['value'];
                    }
                    payload[data['name']] = data['value'];
                }
            });
            //console.log(payload)
            if (slug === 'units') {
                postService(createUnit, 'POST', payload).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Unit Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      }); 
                   }
                })
            }
            if (slug === 'departments') {
                postService(createDepartment, 'POST', payload).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Department Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            if (slug === 'service-group') {
                postService(createService, 'POST', payload).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'service Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            if (slug === 'services') {
                postService(createMasterService, 'POST', {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'service Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            if (slug === 'doctors') {
                const Userlogobj ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Create Doctor - Request",
                        "date": new Date(),
                        "meta": payload
                    }
                }
                userTrackService(Userlogobj);
                postService(createDoctor, 'POST', payload).then(res => {
                    const Userlogobjres ={
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Create Doctor - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                userTrackService(Userlogobjres);
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'service Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            
        }
    }


    editData(){
        var formFeilds = this.state.formData;
        let errors = this.validateModalFeilds(formFeilds)
        const {slug} = this.props.match.params;
        const {editDoctor,editUnit,editDepartment,editService} = networkList;

        if (!errors.includes(false)) {
            let payload= {};
            formFeilds.map(data=>{
                if(data['element']=== 'input' || data['element']=== 'select2'){
                    if(data['name'] === 'department'){
                        payload['departmentId'] = data['value'];
                    }
                    payload[data['name']] = data['value'];
                }
            });
            payload['id'] = this.state.editModalData['id'];
            
            //console.log(payload);
            if (slug === 'units') {
                postService(editUnit, 'POST', {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Unit Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      }); 
                   }
                })
            }
            if (slug === 'departments') {
                postService(editDepartment, 'POST',  {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Department Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }


            if (slug === 'service-group') {
                postService(editService, 'POST',  {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Department Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            if (slug === 'services') {
                postService(editService, 'POST',  {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Department Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }

            if (slug === 'doctors') {

                postService(editDoctor, 'POST',  {data:payload}).then(res => {
                   if(res.status){
                    let This = this;
                    Modal.success({
                        zIndex:1500,
                        maskClosable:false,
                        title: 'Success',
                        content: 'Department Created Successfully',
                        onOk(){
                            This.fetchListData();
                            This.setModalVisible(false); 
                        }
                      });
                       
                   }
                })
            }
        }
    }

    validateModalFeilds(formFeilds){
        let errors =[];
        formFeilds.map((feild,key)=>{
            if(feild['element']=== 'input' || feild['element']=== 'select2'){
                formFeilds[key]['errors'] = [];
                if(!feild.disable){
                    feild
                    .rules
                    .map((rule, rkey) => {
                        if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                            formFeilds[key]['errors'].push({'message': rule.message});
                            errors.push(false);
                        }
                    })
                }
            }
        })
        if(this.state.queue_list.length === 0){
            formFeilds.map((feild,key)=>{
               
                if(feild['name']=== 'new_queues' && feild['element']=== 'select2'){
                    formFeilds[key]['errors'] = [];    
                    formFeilds[key]['errors'].push({'message': "Please Select a Queue"});
                    errors.push(false);
                }
            })
        }
        this.setState((state) => ({formData: formFeilds}));
        return errors;
    }


    onQueuenameChange($event,id){
        //console.log($event.target.value,id);

        function add(arr, value) {
                arr.filter((data,key)=>{
                    const found = arr.some(el => el.qListName === value);
                    arr[key]['message'] = null;
                    if(data.qListId === id){
                        if (!found){
                            arr[key]['qListName'] = value
                        }
                        if(found){
                            arr[key]['message'] = 'Queue Name already Exists';
                        }
                    }
               })
            return arr;
        }
     
        //console.log(this.state.queue_list);
        let arrayData = add(this.state.queue_list,$event.target.value);
        this.setState((state)=>({'queue_list':arrayData}));
       
    }


    handleFormInputChange(evnt){
        //console.log(evnt);
        var formFeilds = this.state.formData;
        formFeilds.map((feild,key)=>{
            if(feild['name'] === evnt['name']){
                formFeilds[key]['value'] = evnt['value'];
                formFeilds[key]['valid'] = true;
            }
        });
        this.setState((state)=>({formData:formFeilds}),()=>{
            this.validateModalFeilds(this.state.formData);
        });
        
    }


    queueRemove(id,evt){
        this.state.queue_list.splice(id,1);
        this.setState((state) => ({date: new Date()}));
    }

    deleteclick(data){
        let{deleteTvDisplay,deleteQueueDoctor} = networkList;
        const {id,slug} = this.props.match.params;
        //console.log(id);
        if(slug ==='tv-displays'){
            var This = this
            Modal.confirm({
                zIndex:1040,
                maskClosable:false,
                title:'Confirmation',
                content:'Are You shure you want to delete this User',
                onOk(){
                    postService(deleteTvDisplay,'POST',{data}).then((res)=>{
                        if(res.status){
                            This.fetchListData();
                        }
                    })
                }
            })
        }

        if(slug ==='radiologist'){
            var This = this
            Modal.confirm({
                zIndex:1040,
                maskClosable:false,
                title:'Confirmation',
                content:'Are You shure you want to delete this User',
                onOk(){
                    postService(deleteQueueDoctor,'POST',{'data':{'doctor_id':data['doctor_id']}}).then((res)=>{
                        if(res.status){
                            This.fetchListData();
                        }
                    })
                }
            })
        }
    }
   
    render() {
        let premissions ={};
        const {list, formData} = this.state;
        const {id,slug} = this.props.match.params;
        const {menuList} = this.props;
        const tvToken = Storage.get('tv_display_id') 
        menuList.map((menu,key)=>{
            if(id === menu['route']){
                menu['submenu'].map((smenu,skey)=>{
                    if(slug === smenu['route']){
                        premissions = smenu['permissions'];
                    }
                })
            }
        });
        if (list.length != 0 || formData.length != 0) {
            return (
                <React.Fragment>
                    {(slug === 'start-counter') && <React.Fragment>
                    {(tvToken == null || tvToken == undefined)&&
                    <div className="col-5 m-auto">
                        <div className="card py-4 mt-5">
                        <form noValidate>
                                {loginSchema
                                    .feilds
                                    .map((feild, key) => {
                                        if (feild.element === 'label') {
                                            return (
                                                <div className="row mb-4" key={key}>
                                                    <div className="col-8 mx-auto">
                                                        <h2 className="text-center">{feild.text}</h2>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        if (feild.element === 'input') {
                                            return (
                                                <div className="row mb-4" key={key}>
                                                    <div className="col-8 mx-auto">
                                                        <Inputlayer
                                                            {...this.props}
                                                            {...this.state}
                                                            key={key}
                                                            feildData={feild}
                                                            onInputChanges={this
                                                            .forminputChangedState
                                                            .bind(this)}/>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        if (feild.element === 'button') {
                                            return (
                                                <div className="row mb-4" key={key}>
                                                    <div className="col-8 mx-auto  text-center">
                                                        <button
                                                           className="btn btn-dark"
                                                            type="button"
                                                            onClick={this
                                                            .login
                                                            .bind(this)}>Sign In</button>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                            </form>
                            </div>
                    </div>
                    }
                    {(tvToken != null || tvToken != undefined)&&

                        <div className="tv-counter-data">
                            <div className="py-3 counter-card h-100">
                                <div className="row">
                                    <div className="col-12">
                                    <div className="col-12 reports-details counter-details">
                    <div className="card">
                        <table>
                            <tr className="row head-row">
                                {/* <th className="col-3 my-auto">Doctor</th> */}
                                <th className="col-3 my-auto">Room No</th>
                                <th className="col my-auto">NOW</th>
                                <th className="col my-auto">NEXT</th>
                            </tr>
                        </table>
                    </div>
                    <div className="card">
                        <table className="table-body">
                            {this.state.counter_data.map((data,key)=>{
                                let now =[];
                                let next =[];
                                data.queue_rows.map((row,rkey)=>{
                                    if(row.checkKey !== undefined && row.checkKey !== null){
                                        if(row.checkKey === 'now'){
                                               now.push(row);
                                            }
                                            if(row.checkKey === 'next'){
                                                next.push(row);
                                            }
                                    }
                                            
                                        })


                                return(
                                    <tr className="row tv-row" key={key}>
                                        <td className="col-3 my-auto order-1">{data.queue_list_id}</td>
                                        {(now.length ===0)&& <td className="col my-auto order-2">--</td>}
                                        {(now.length !==0)&& <React.Fragment><td className="col my-auto order-3" >{now[0].umr}</td></React.Fragment>}
                                        {(next.length ===0)&& <td className="col my-auto order-3">--</td>}
                                        {(next.length !==0)&& <React.Fragment><td className="col my-auto order-3">{next[0].umr}</td></React.Fragment>}
                                       
                                    </tr>
                                );
                            })}
                        </table>
                    </div>
                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                   
                    }</React.Fragment>}
                    {(slug !== 'start-counter') && <React.Fragment>
                        <div className="custom-container">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        {(this.state.slug !== 'addrole'   && this.state.slug !== 'editradiologist' && this.state.slug !== 'addradiologist'  && this.state.slug !== 'edittvscreen' && this.state.slug !== 'viewrole' && this.state.slug !== 'editUser' && this.state.slug !== 'editrole' && this.state.slug !== 'addUser' && this.state.slug !== 'addtvscreen') &&<h6 className = "text-capitalize" > {
                                            this.state.slugText ? this.state.slugText : slug
                                        } </h6>}
                                        {(this.state.slug === 'addrole') && <h6 className="text-capitalize">Add New Role</h6>}
                                        {(this.state.slug === 'editrole') && <h6 className="text-capitalize">Edit Role</h6>}
                                        {(this.state.slug === 'viewrole') && <h6 className="text-capitalize">View Role</h6>}
                                        {(this.state.slug === 'addUser') && <h6 className="text-capitalize">Add New User</h6>}
                                        {(this.state.slug === 'editUser') && <h6 className="text-capitalize">Edit User</h6>}
                                        {(this.state.slug === 'addtvscreen') && <h6 className="text-capitalize">Add New TV Display</h6>}
                                        {(this.state.slug === 'addradiologist') && <h6 className="text-capitalize">Add New Radiologist</h6>}
                                        {(this.state.slug === 'editradiologist') && <h6 className="text-capitalize">Edit Radiologist</h6>}
                                        {(this.state.slug === 'edittvscreen') && <h6 className="text-capitalize">Edit TV Display</h6>}
                                    </div>
                                    <div className="col-12 mt-2">
                                        {(this.state.slug != null && this.state.slug !== 'editradiologist' && this.state.slug !== 'addradiologist' && this.state.slug != 'edittvscreen' &&  this.state.slug != 'addrole' &&  this.state.slug !== 'viewrole' && this.state.slug !== 'editrole' && this.state.slug != 'addUser'  && this.state.slug != 'editUser' && this.state.slug != 'addtvscreen') && <div className="table-container">
                                            <div className="col-12 mb-4">
                                                <div className="row justify-content-end">
                                                    <div className="col-2">
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search"
                                                                aria-label="search"/></div>
                                                    </div>
                                                    {(premissions['add'] === 'true')&&
                                                    <div className="col-3">
                                                        {(this.state.slug != null && this.state.slug !== 'roles' && this.state.slug !== 'users' && this.state.slug !== 'tvscreen' && this.state.slug !== 'radiologist') && <button
                                                            type="button"
                                                            className="btn btn-dark w-100 text-capitalize"
                                                            onClick={() => this.setModalVisible(true)}>Add New {this.state.slugText ? this.state.slugText : slug}</button>}
                                                            {/* {(this.state.slug != null && this.state.slug !== 'roles' && this.state.slug !== 'users' && this.state.slug !== 'tvscreen' && this.state.editModalData !== null ) && <button
                                                            type="button"
                                                            className="btn btn-dark w-100 sss"
                                                            onClick={() => this.setModalVisible(true)}>Edit {this.state.slug}</button>} */}
                                                        {(this.state.slug != null && this.state.slug === 'roles') && <button
                                                            type="button"
                                                            className="btn btn-dark w-100"
                                                            onClick={this
                                                            .gotoAddRole
                                                            .bind(this)}>Add New {this.state.slug}</button>}
                                                        {(this.state.slug != null && this.state.slug === 'users') && <button
                                                            type="button"
                                                            className="btn btn-dark w-100"
                                                            onClick={this
                                                            .gotoAddusers
                                                            .bind(this)}>Add New {this.state.slug}</button>}
                                                        {(this.state.slug != null && this.state.slug === 'tvscreen') && <button
                                                            type="button"
                                                            className="btn btn-dark w-100"
                                                            onClick={this
                                                            .gotoaddTvScreen
                                                            .bind(this)}>Add New {this.state.slug}</button>}

                                                        {(this.state.slug != null && this.state.slug === 'radiologist') && <button
                                                            type="button"
                                                            className="btn btn-dark w-100"
                                                            onClick={this
                                                            .gotoaddradiologist
                                                            .bind(this)}>Add New Radiologist</button>}
                                                    </div>}
                                                    
                                                </div>
                                            </div>
                                            <table className="table table-hover table-borderless mb-0">
                                                <thead>
                                                    <tr>
                                                        {this
                                                            .state
                                                            .list
                                                            .map((data, key) => {
                                                                if (data.visible) {
                                                                    return (
                                                                        <th
                                                                            key={key}
                                                                            className={`align-middle ${data.className
                                                                            ? data.className
                                                                            : ''}`}>{data.text}</th>
                                                                    );
                                                                }
                                                            })}
                                                    </tr>

                                                </thead>
                                                <tbody>

                                                    {this
                                                        .state
                                                        .tbody
                                                        .map((data, key) => {

                                                            return (
                                                                <tr key={key}>
                                                                <td className="align-middle text-center">{key + 1}</td>
                                                                 {this.state.list.map((feild,key)=>{
                                                                    return (Object.keys(data).map((Okey,ookey) => {
                                                                       
                                                                        if (Okey === feild['name']) {
                                                                           
                                                                            if (Okey === 'status') {
                                                                                return (<td className="align-middle" key={ookey}><Switch
                                                                                    defaultChecked
                                                                                    onChange={this
                                                                                    .onSwitcjChange
                                                                                    .bind(this, data)}/></td>);
                                                                            }else if(Okey ==='queue_list'){
                                                                                return (<React.Fragment>
                                                                                    <td className="align-middle p-0" key={ookey}><table className="table table-condensed table-bordered m-0">{data[Okey].map((qdata,qdataKey)=>{return<tr key ={qdataKey}><td className="mb-1">{`${qdata['queue_list_id']? qdata['queue_list_id']: 'NA'}`}</td> <td>{`${qdata['queue_list_name']? qdata['queue_list_name']: 'NA'}`}</td></tr>})}</table></td>
                                                                                    </React.Fragment>);
                                                                            }else if(Okey ==='service_time'){
                                                                                return (
                                                                                    <td className="align-middle" key={ookey}>{`${data[Okey]? data[Okey]: 'NA'} Min`}</td>
                                                                                );
                                                                            }else{
                                                                                return (
                                                                                    <td className="align-middle" key={ookey}>{data[Okey]? data[Okey]: 'NA'}</td>
                                                                                );
                                                                            }
                                                                        }
                                                                    
                                                                       

                                                                    }));
                                                                 })}
                                                                    
                                                                    
                                                                    
                                                                    <td className="align-middle">
                                                                        {(slug === 'roles' && premissions['view']==='true')&&<Button
                                                                        type="link"
                                                                        icon="eye"
                                                                        style={{"color": "#364152","font-size": "20px"}}
                                                                        onClick={this
                                                                                    .viewclick
                                                                                    .bind(this, data['id'])}/>}
                                                                        {(this.state.slug !== 'roles'  && premissions['edit']==='true')&&<Button
                                                                        type="link"
                                                                        icon="edit"
                                                                        style={{"color": "#364152","font-size": "20px"}}
                                                                        onClick={this.editclick.bind(this, data)}/>}
                                                                        {(slug === 'tv-displays'  && premissions['delete']==='true')&&<Button
                                                                        type="link"
                                                                        icon="delete"
                                                                        style={{"color": "#364152","font-size": "20px"}}
                                                                        onClick={this
                                                                                    .deleteclick
                                                                                    .bind(this, data)}/>}
                                                                                    


                                                                                    
                                                                        {(slug === 'radiologist' && premissions['delete']==='true')&&<Button
                                                                        type="link"
                                                                        icon="delete"
                                                                        style={{"color": "#364152","font-size": "20px"}}
                                                                        onClick={this
                                                                                    .deleteclick
                                                                                    .bind(this, data)}/>}



                                                                        </td>
                                                                </tr>
                                                            );

                                                        })}

                                                </tbody>
                                            </table>
                                        </div>}

                                        {(this.state.slug != null && (this.state.slug === 'editradiologist' || this.state.slug === 'addradiologist' || this.state.slug === 'addUser' || this.state.slug === 'editUser' || this.state.slug === 'addtvscreen' || this.state.slug === 'edittvscreen')) &&<div className = "row" > <div className="col-12 mb-3">
                                            <div className="card">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <figure className="w-100 m-0 queue-imahe h-100">
                                                            <img
                                                                src="/assets/images/icons/kims-h-image.png"
                                                                alt="bg"
                                                                className="w-100 h-100"/>
                                                        </figure>
                                                    </div>
                                                    <div className="col-6 p-5">
                                                        <form noValidate>
                                                            {this
                                                                .state
                                                                .formData
                                                                .map((feild, key) => {
                                                                    if (feild.element === 'label' && this.state.slug !== 'editUser' && this.state.slug !== 'edittvscreen' && this.state.slug !== 'editradiologist') {

                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 mx-auto">
                                                                                    <h2 className="text-left">{feild.text}</h2>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'label' && this.state.slug === 'edittvscreen') {

                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 mx-auto">
                                                                                    <h2 className="text-left">Edit TV Display</h2>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'label' && this.state.slug === 'editUser') {

                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 mx-auto">
                                                                                    <h2 className="text-left">Edit User Details</h2>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'label' && this.state.slug === 'editradiologist') {

                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 mx-auto">
                                                                                    <h2 className="text-left">Edit Radiologist Details</h2>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'input') {
                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 mx-auto">
                                                                                    <Inputlayer
                                                                                        {...this.props}
                                                                                        {...this.state}
                                                                                        key={key}
                                                                                        feildData={feild}
                                                                                        onInputChanges={this
                                                                                        .handleChange
                                                                                        .bind(this)}/>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'select2') {
                                                                    if(feild.name == 'queues'){
                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 my-auto">
                                                                                    <Select2
                                                                                        key={key}
                                                                                        selectdata={feild}
                                                                                        changedObj={this.state.changedObj}
                                                                                        {...this.props}
                                                                                        {...this.state}
                                                                                        Queuedata={this.state.formData}
                                                                                        onselectChanges={this
                                                                                        .handleChange
                                                                                        .bind(this)}/>
                                                                                       
                                                                                </div>
                                                                               
                                                                                <div className="col-12 mt-4">
                                                                                    <table className="w-100 table table-hover">
                                                                                    <thead className="thead-light">
                                                                                        <tr>
                                                                                            <th>Queue ID</th>
                                                                                            <th>Name</th>
                                                                                            <th>Actions</th>
                                                                                        </tr>
                                                                                    </thead>   
                                                                                    <tbody className="w-100">
                                                                                        {this.state.queue_list.map((data,key)=>{
                                                                                            return(<tr key={key}>
                                                                                            <td className="p-2">{data.qListId}</td>
                                                                                            <td className="p-2">
                                                                                            
                                                                                            <span className="ant-input-affix-wrapper">
                        
                                                                                                <input defaultValue={data.qListName}  type='text'  name='list_name'
                                                                                                                    onBlur={(e)=>this.onQueuenameChange(e,data.qListId)}
                                                                                                                   
                                                                                                                    placeholder="Queue Name" className="ant-input" />
                                                                                            </span>
                                                                                            <small className="form-text text-danger">{data.message}</small>
                                                                                            </td>
                                                                                            <td className="p-2"><Button
                                                                        type="link"
                                                                        icon="delete"
                                                                        onClick={this
                                                                    .queueRemove
                                                                    .bind(this, key)}/></td>
                                                                                        </tr>)

                                                                                        })}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }else if(feild.name == 'new_queues'){
                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <div className="col-12 my-auto">
                                                                                    <Select2
                                                                                        key={key}
                                                                                        selectdata={feild}
                                                                                        changedObj={this.state.changedObj}
                                                                                        {...this.props}
                                                                                        {...this.state}
                                                                                        Queuedata={this.state.formData}
                                                                                        onselectChanges={this
                                                                                        .handleChange
                                                                                        .bind(this)}/>
                                                                                       
                                                                                </div>
                                                                               
                                                                                <div className="col-12 mt-4">
                                                                                    <table className="w-100 table table-hover">
                                                                                    <thead className="thead-light">
                                                                                        <tr>
                                                                                            <th>Room Name</th>
                                                                                            <th>Actions</th>
                                                                                        </tr>
                                                                                    </thead>   
                                                                                    <tbody className="w-100">
                                                                                        {this.state.queue_list.map((data,key)=>{
                                                                                            return(<tr key={key}>
                                                                                            <td className="p-2">{data.qListname || data.qListName}</td>
                                                                                           
                                                                                            <td className="p-2"><Button
                                                                                        type="link"
                                                                                        icon="delete"
                                                                                        onClick={this
                                                                                    .queueRemove
                                                                                    .bind(this, key)}/></td>
                                                                                                        </tr>)

                                                                                        })}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                                <div className="col-12">
                                                                                    {(this.state.queue_list.length === 0) &&
                                                                                       <small className="form-text text-danger">Please Select a Queue</small> 
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }else{
                                                                       
                                                                        if(this.state.slug === 'edittvscreen' && feild.disable){
                                                                            
                                                                            return (
                                                                                <div className="row mb-4" key={key}>
                                                                                    <div className="col-12 mx-auto">
                                                                                        <p className="mb-0 form-control disabled f-14">{feild.text}</p>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }else if(this.state.slug === 'editUser' && feild.disable){
                                                                           
                                                                            return (
                                                                                <div className="row mb-4" key={key}>
                                                                                    <div className="col-12 mx-auto">
                                                                                        <p className="mb-0 form-control disabled f-14">{feild.text ?feild.text:'All'}</p>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }else{
                                                                            return (
                                                                                <div className="row mb-4" key={key}>
                                                                                    <div className="col-12 mx-auto">
                                                                                        <Select2
                                                                                            key={key}
                                                                                            selectdata={feild}
                                                                                            changedObj={this.state.changedObj}
                                                                                            {...this.props}
                                                                                            {...this.state}
                                                                                            Queuedata={this.state.formData}
                                                                                            onselectChanges={this
                                                                                            .handleChange
                                                                                            .bind(this)}/>
                                                                                             {feild.errors.map((error,key)=>{
                                                                                            return ( <small className="form-text text-danger" key={key}>{error.message}</small>);
                                                                                        })}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                    }
                                                                    if (feild.element === 'table') {
                                                                        return (
                                                                            <div className="row mb-4" key={key}>
                                                                                <Btable feild={feild} {...this.props} {...this.state}/>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    if (feild.element === 'button') {
                                                                        if(this.state.slug === 'edittvscreen' || this.state.slug === 'editUser' || this.state.slug === 'editradiologist'){
     return (
                                                                                <div className="row mb-4" key={key}>
                                                                                    <div className="col-5 mx-auto">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-dark w-100"
                                                                                            onClick={this
                                                                                            .addUser
                                                                                            .bind(this)}>Edit {feild.text}</button>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }else{
                                                                            return (
                                                                                <div className="row mb-4" key={key}>
                                                                                    <div className="col-5 mx-auto">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-dark w-100"
                                                                                            onClick={this
                                                                                            .addUser
                                                                                            .bind(this)}>Add {feild.text}</button>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                })}
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> </div>}

                                        

                                        {(this.state.slug != null && this.state.slug === 'viewrole') && <div className="table-container px-5">
                                            {this
                                                .state
                                                .formData
                                                .map((feild, key) => {
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div className="row" key={key}>
                                                                <div className="col-3">
                                                                <div className="form-group row static">
                                                                    {/* <label for="staticEmail" className="col-4 col-form-label pr-0">Role Name:</label> */}
                                                                    <div className="col-12 my-auto pl-0">
                                                                        <p  id="staticEmail" className="mb-0 form-control">{this.state.roleData.name}</p>
                                                                    </div>
                                                                </div>
                                                                    {/* <Inputlayer
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        key={key}
                                                                        feildData={feild}
                                                                        onInputChanges={this
                                                                        .inputChangedState
                                                                        .bind(this)}/> */}
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    if (feild.element === 'table') {
                                                        return (<Btable
                                                            feild={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            editFeilds={this.editfeilds.bind(this)}
                                                            permissionsTablechange={this
                                                            .permissionsTablechange
                                                            .bind(this)}/>);
                                                    }
                                                    if (feild.element === 'button') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                {(this.state.slug == 'addrole')&&<div className="col-3 mx-auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-dark w-100"
                                                                        onClick={this
                                                                        .addnewRole
                                                                        .bind(this)}>{feild.text}</button>
                                                                </div>}
                                                                {(this.state.slug == 'editrole')&&<div className="col-3 mx-auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-dark w-100"
                                                                        onClick={this
                                                                        .addnewRole
                                                                        .bind(this)}>Edit Role</button>
                                                                </div>}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </div>}


                                        {(this.state.slug != null && (this.state.slug == 'addrole' || this.state.slug === 'editrole')) && <div className="table-container px-5">
                                            {this
                                                .state
                                                .formData
                                                .map((feild, key) => {
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                <div className="col-3">
                                                                    <Inputlayer
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        key={key}
                                                                        feildData={feild}
                                                                        onInputChanges={this
                                                                        .inputChangedState
                                                                        .bind(this)}/>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    if (feild.element === 'table') {
                                                        return (<Btable
                                                            feild={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            editFeilds={this.editfeilds.bind(this)}
                                                            permissionsTablechange={this
                                                            .permissionsTablechange
                                                            .bind(this)}/>);
                                                    }
                                                    if (feild.element === 'button') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                {(this.state.slug == 'addrole')&&<div className="col-3 mx-auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-dark w-100"
                                                                        onClick={this
                                                                        .addnewRole
                                                                        .bind(this)}>{feild.text}</button>
                                                                </div>}
                                                                {(this.state.slug == 'editrole')&&<div className="col-3 mx-auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-dark w-100"
                                                                        onClick={this
                                                                        .addnewRole
                                                                        .bind(this)}>Edit Role</button>
                                                                </div>}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </div>}

                                    </div>
                                </div>
                            </div>
                            <Modal
                                title=''
                                centere
                                className='admin-addform'
                                footer={null}
                                width='80%'
                                zIndex='1200'
                                closable={false}
                                destroyOnClose={true}
                                maskClosable={false}
                                visible={this.state.modalVisible}
                                onOk={() => this.setModalVisible(false)}
                                onCancel={() => this.setModalVisible(false)}>

                                <div className="row">
                                    <div className="col-6 position-relative figure-block">
                                        <figure>
                                            <img
                                                src="/assets/images/icons/kims-h-image.png"
                                                alt="bg"
                                                className="w-100 h-100"/>
                                        </figure>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                            Lorem Ipsum has been the industry's standard dummy text .</p>
                                    </div>
                                    <div className="col-6 position-relative form-block py-4 pr-5">
                                        <form noValidate>
                                            {this
                                                .state
                                                .formData
                                                .map((feild, key) => {
                                                    if (feild.element === 'label') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                <div className="col-12 mx-auto">
                                                                    <h2 className="text-left">{feild.text}</h2>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                <div className="col-12 mx-auto">
                                                                    <Inputlayer
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        key={key}
                                                                        feildData={feild}
                                                                        onInputChanges={this
                                                                        .handleFormInputChange
                                                                        .bind(this)}/>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    if (feild.element === 'select2') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                <div className="col-12 mx-auto">
                                                                    <Select2
                                                                        key={key}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        Queuedata={this.state.formData}
                                                                        onselectChanges={this
                                                                        .handleFormInputChange
                                                                        .bind(this)}/>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                   
                                                    if (feild.element === 'button') {
                                                        return (
                                                            <div className="row mb-4" key={key}>
                                                                {(this.state.editModalData !== null)&& <div className="col-12 mx-auto">
                                                                    <button type="button" onClick={this.editData.bind(this)}>{`Edit ${feild.text}`}</button>
                                                                </div>}
                                                                {(this.state.editModalData === null)&& <div className="col-12 mx-auto">
                                                                    <button type="button" onClick={this.createData.bind(this)}>{`Add ${feild.text}`}</button>
                                                                </div>}
                                                                
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </form>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </React.Fragment>}
                </React.Fragment>
            );
        } else {
            return (
                <Accesspage></Accesspage>
            );
        }
    }
}
export default MasterList;
